<section class="anc-section">
    @if (showHeader()) {
        <button
            type="button"
            class="anc-section__header"
            (click)="toggle()"
            [attr.aria-expanded]="!collapsed()"
        >
            <h6 class="anc-section__title" translate>{{ title() }}
                <span class="anc-section__subtitle" translate>{{ subtitle() }}</span>
            </h6>
            <i
                class="anc-section__chev icon icon--24"
                [class.icon-chevron-down]="collapsed()"
                [class.icon-chevron-up]="!collapsed()"
                aria-hidden="true"
            ></i>
        </button>
    } @else if (title()) {
        <!-- Not collapsible (single section) but still has a title — show it
             as static text, just without the toggle affordance. Sections with
             no title at all (the side-panel title carries the label instead)
             render no header row, same as before. -->
        <div class="anc-section__header anc-section__header--static">
            <h6 class="anc-section__title" translate>{{ title() }}
                <span class="anc-section__subtitle" translate>{{ subtitle() }}</span>
            </h6>
        </div>
    }
    @if (!showHeader() || !collapsed()) {
        <div class="anc-section__body">
            <ng-content></ng-content>
        </div>
    }
</section>
